import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import EditEmail from "../../../components/EditEmail";
import { setUserData } from "../../../redux/member";
import { RootState } from "../../../redux/store";
import { updateEmailAddress } from "../../../services/memberService";
import QuestionUpdateHeader from "./QuestionUpdateHeader";

const UpdateEmail = () => {
    const member = useSelector((state: RootState) => state.member);
    const history = useHistory();
    const dispatch = useDispatch();

    const onSave = async (value: string) => {
        try {
            await updateEmailAddress(member.memberCode, value);
            member.email = value;
            dispatch(setUserData(member));
            history.goBack();
        }
        catch (error) {
            //show alert or something else
            console.error(error);
        }
    };

    return (<>
        <>
            <QuestionUpdateHeader />
            <EditEmail
                isEditMode={true}
                buttonText={"שמור"}
                subtitle={""}
                title={"שינוי כתובת אימייל"}
                value={undefined} onSave={onSave} />
        </>
    </>)
}

export default UpdateEmail;